"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
var React = require("react");
var input_1 = require("wix-ui-core/dist/src/components/input");
var TextField_st_css_1 = require("./TextField.st.css");
var Error_1 = require("wix-ui-icons-common/on-stage/Error");
var Check_1 = require("wix-ui-icons-common/on-stage/Check");
var ClearXSmall_1 = require("wix-ui-icons-common/on-stage/system/ClearXSmall");
var IconButton_1 = require("../IconButton");
var TooltipEnums_1 = require("../Tooltip/TooltipEnums");
var TextFieldEnums_1 = require("./TextFieldEnums");
var dataKeys_1 = require("./dataKeys");
var IconTooltip_1 = require("../IconTooltip");
var uniqueId = require('lodash/uniqueId');
var TextField = /** @class */ (function (_super) {
    __extends(TextField, _super);
    function TextField(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this._rootRef = React.createRef();
        _this.state = {
            isErrorTooltipShown: false,
        };
        _this.TextFieldRef = React.createRef();
        _this.focus = function () {
            _this.TextFieldRef.current.focus();
        };
        _this.blur = function () {
            _this.TextFieldRef.current.blur();
        };
        _this.showErrorTooltip = function () {
            _this._toggleTooltip(true);
        };
        _this.hideErrorTooltip = function () {
            _this._toggleTooltip(false);
        };
        _this._getClearButton = function (shouldAddClearButtonGap) {
            var _a = _this.props, clearButtonAriaLabel = _a.clearButtonAriaLabel, clearButtonAriaLabelledby = _a.clearButtonAriaLabelledby, onClear = _a.onClear;
            return (React.createElement("div", { className: TextField_st_css_1.classes.clearButtonWrapper },
                React.createElement(IconButton_1.IconButton, { className: TextField_st_css_1.classes.clearButton, "data-hook": dataKeys_1.DATA_HOOKS.CLEAR_BUTTON, "aria-label": clearButtonAriaLabel, "aria-labelledby": clearButtonAriaLabelledby, skin: IconButton_1.Skins.Line, onClick: onClear ? function () { return _this.props.onClear(); } : undefined, icon: React.createElement(ClearXSmall_1.default, null) }),
                shouldAddClearButtonGap && React.createElement("div", { className: TextField_st_css_1.classes.clearButtonGap })));
        };
        _this._getErrorSuffix = function () {
            var isErrorTooltipShown = _this.state.isErrorTooltipShown;
            var _a = _this.props, errorMessage = _a.errorMessage, errorTooltipPlacement = _a.errorTooltipPlacement, errorTooltipMaxWidth = _a.errorTooltipMaxWidth;
            return (React.createElement(IconTooltip_1.IconTooltip, { "data-hook": dataKeys_1.DATA_HOOKS.ERROR_ICON, message: errorMessage, icon: React.createElement(Error_1.default, { className: TextField_st_css_1.classes.errorIcon }), tooltipId: _this._errorMessageId, tooltipSkin: TooltipEnums_1.TooltipSkin.Error, showTooltip: isErrorTooltipShown, onClick: _this._onErrorButtonClick, onClickOutside: _this._onClickOutside, tooltipProps: {
                    placement: errorTooltipPlacement,
                    moveBy: { x: 5, y: 0 },
                    maxWidth: errorTooltipMaxWidth,
                } }));
        };
        _this._getSuccessSuffix = function () {
            return (React.createElement(Check_1.default, { "data-hook": dataKeys_1.DATA_HOOKS.SUCCESS_ICON, className: TextField_st_css_1.classes.successIcon }));
        };
        _this._getSuffix = function () {
            var _a = _this.props, error = _a.error, errorMessage = _a.errorMessage, success = _a.success, successIcon = _a.successIcon, suffix = _a.suffix, withClearButton = _a.withClearButton, value = _a.value, disabled = _a.disabled;
            var shouldShowCustomSuffix = !!suffix;
            var shouldShowErrorIcon = error && errorMessage;
            var shouldShowSuccessIcon = successIcon && success;
            var shouldShowClearButton = withClearButton && value && !disabled;
            var shouldAddClearButtonGap = shouldShowCustomSuffix || shouldShowErrorIcon || shouldShowSuccessIcon;
            var hasSuffix = shouldShowCustomSuffix ||
                shouldShowErrorIcon ||
                shouldShowSuccessIcon ||
                shouldShowClearButton;
            return hasSuffix ? (React.createElement("div", { className: TextField_st_css_1.classes.suffixWrapper },
                shouldShowClearButton
                    ? _this._getClearButton(shouldAddClearButtonGap)
                    : null,
                shouldShowErrorIcon ? _this._getErrorSuffix() : null,
                shouldShowSuccessIcon ? _this._getSuccessSuffix() : null,
                suffix ? (React.createElement("div", { className: TextField_st_css_1.classes.customSuffix, "data-hook": dataKeys_1.DATA_HOOKS.CUSTOM_SUFFIX }, suffix)) : null)) : null;
        };
        _this._getPrefix = function () {
            var _a = _this.props, prefix = _a.prefix, prefixLabel = _a.prefixLabel;
            return prefix ? (React.createElement("span", { "data-hook": dataKeys_1.DATA_HOOKS.PREFIX, className: TextField_st_css_1.classes.prefix },
                prefix,
                prefixLabel ? (React.createElement("span", { id: _this._prefixLabelId, className: TextField_st_css_1.classes.prefixLabel, "data-sr-only": "true", "data-hook": dataKeys_1.DATA_HOOKS.PREFIX_LABEL }, prefixLabel)) : null)) : null;
        };
        _this._toggleTooltip = function (showTooltip) {
            _this.setState({ isErrorTooltipShown: showTooltip });
        };
        _this._onErrorButtonClick = function () {
            var isErrorTooltipShown = _this.state.isErrorTooltipShown;
            _this._toggleTooltip(!isErrorTooltipShown);
        };
        _this._onClickOutside = function () {
            if (_this._rootRef.current &&
                !_this._rootRef.current.contains(document.activeElement)) {
                _this._toggleTooltip(false);
            }
        };
        _this._onFocus = function (e) {
            var onFocus = _this.props.onFocus;
            if (onFocus) {
                onFocus(e);
            }
            if (!e.defaultPrevented &&
                _this._rootRef.current &&
                _this._rootRef.current.contains(document.activeElement)) {
                _this._toggleTooltip(true);
            }
        };
        _this._inputId = (_a = props.id) !== null && _a !== void 0 ? _a : uniqueId('label-for-id');
        _this._errorMessageId = uniqueId('error-message');
        _this._prefixLabelId = uniqueId('prefix-label');
        return _this;
    }
    TextField.prototype.render = function () {
        var _a;
        var _b = this.props, errorMessage = _b.errorMessage, success = _b.success, successIcon = _b.successIcon, error = _b.error, disabled = _b.disabled, theme = _b.theme, suffix = _b.suffix, prefix = _b.prefix, prefixLabel = _b.prefixLabel, className = _b.className, withClearButton = _b.withClearButton, onClear = _b.onClear, clearButtonAriaLabel = _b.clearButtonAriaLabel, clearButtonAriaLabelledby = _b.clearButtonAriaLabelledby, errorTooltipPlacement = _b.errorTooltipPlacement, label = _b.label, maxLength = _b.maxLength, showCharCount = _b.showCharCount, value = _b.value, forceLabel = _b.forceLabel, ariaDescribedBy = _b["aria-describedby"], restProps = __rest(_b, ["errorMessage", "success", "successIcon", "error", "disabled", "theme", "suffix", "prefix", "prefixLabel", "className", "withClearButton", "onClear", "clearButtonAriaLabel", "clearButtonAriaLabelledby", "errorTooltipPlacement", "label", "maxLength", "showCharCount", "value", "forceLabel", 'aria-describedby']);
        var dataObject = (_a = {},
            _a[dataKeys_1.THEME] = theme,
            _a[dataKeys_1.SUCCESS] = success,
            _a[dataKeys_1.ERROR] = error,
            _a[dataKeys_1.EMPTY] = !this.props.value,
            _a);
        var hasPrefix = prefix ? true : false;
        return (React.createElement("div", { className: TextField_st_css_1.st(TextField_st_css_1.classes.root, {
                error: error,
                theme: theme,
                success: success,
                disabled: disabled,
                hasPrefix: hasPrefix,
            }, className), ref: this._rootRef },
            label ? (React.createElement("label", { "data-hook": dataKeys_1.DATA_HOOKS.LABEL, htmlFor: this._inputId, className: TextField_st_css_1.classes.label }, label)) : (forceLabel && (React.createElement("div", { className: TextField_st_css_1.classes.label, "aria-hidden": "true", "data-hook": dataKeys_1.DATA_HOOKS.LABEL_PLACEHOLDER }, "\u00A0"))),
            React.createElement(input_1.Input, __assign({}, dataObject, { className: TextField_st_css_1.st(TextField_st_css_1.classes.input, {
                    theme: theme,
                }), id: this._inputId, "aria-describedby": ((ariaDescribedBy || '') + " " + (errorMessage ? this._errorMessageId : '') + " " + (prefixLabel ? this._prefixLabelId : '')).trim(), value: value, maxLength: maxLength, ref: this.TextFieldRef, suffix: this._getSuffix(), prefix: this._getPrefix(), error: error, "aria-invalid": error }, restProps, { disabled: disabled, onFocus: this._onFocus })),
            maxLength && showCharCount && (React.createElement("div", { "data-hook": dataKeys_1.DATA_HOOKS.CHAR_COUNT, className: TextField_st_css_1.classes.charCount },
                React.createElement("div", { dir: "ltr" }, value.length + "/" + maxLength)))));
    };
    TextField.displayName = 'TextField';
    TextField.defaultProps = {
        success: false,
        successIcon: false,
        error: false,
        withClearButton: false,
        disabled: false,
        theme: TextFieldEnums_1.TextFieldTheme.Box,
        errorTooltipPlacement: 'top-end',
        forceLabel: false,
    };
    return TextField;
}(React.Component));
exports.TextField = TextField;
//# sourceMappingURL=TextField.js.map